// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ed40b9a3","453":"a4ba8b7b","732":"68c136fa","977":"934891c5"}[chunkId] + ".chunk.js";
};